import { defineStore } from 'pinia'
import { useRoute } from 'vue-router'

import { computed, ref, watch } from 'vue'

import { useClubRouter } from '@/features/router/useClubRouer.js'

const SUPER_ADMIN_OVERRIDE_STORAGE_KEY = 'fm_super_admin_override'
const DEV_MODE_STORAGE_KEY = 'fm_dev_mode'
const PLAN_VIEW_USER_STORAGE_KEY = 'fm_plan_view_user_id'
const PERMISSION_DEBUG_STORAGE_KEY = 'fmPermissionDebug'

export const useDevModeStore = defineStore('devModeStore', function () {
  const route = useRoute()
  const router = useClubRouter()
  const persistedDevModeEnabled = ref(localStorage.getItem(DEV_MODE_STORAGE_KEY) === 'true')
  const superAdminOverrideEnabled = ref(
    localStorage.getItem(SUPER_ADMIN_OVERRIDE_STORAGE_KEY) === 'true',
  )
  const selectedPlanViewUserId = ref(localStorage.getItem(PLAN_VIEW_USER_STORAGE_KEY) || '')
  const permissionDebugEnabled = ref(localStorage.getItem(PERMISSION_DEBUG_STORAGE_KEY) === 'true')

  function toggleDevMode() {
    const nextValue = !isDevMode.value
    persistedDevModeEnabled.value = nextValue
    router.replace({
      query: {
        ...route.query,
        devMode: nextValue ? 'true' : undefined,
      },
    })
  }

  function toggleSuperAdminOverride() {
    superAdminOverrideEnabled.value = !superAdminOverrideEnabled.value
  }

  function setSuperAdminOverrideEnabled(value) {
    superAdminOverrideEnabled.value = Boolean(value)
  }

  function setSelectedPlanViewUserId(userId) {
    selectedPlanViewUserId.value = String(userId || '').trim()
  }

  function clearSelectedPlanViewUserId() {
    selectedPlanViewUserId.value = ''
  }

  function setPermissionDebugEnabled(value) {
    permissionDebugEnabled.value = Boolean(value)
  }

  function togglePermissionDebug() {
    permissionDebugEnabled.value = !permissionDebugEnabled.value
  }

  const isDevMode = computed(() => route.query.devMode === 'true' || persistedDevModeEnabled.value)

  watch(
    () => route.query.devMode,
    value => {
      if (value === 'true') {
        persistedDevModeEnabled.value = true
      }
    },
    { immediate: true },
  )

  watch(persistedDevModeEnabled, value => {
    localStorage.setItem(DEV_MODE_STORAGE_KEY, String(value))
  })

  watch(superAdminOverrideEnabled, value => {
    localStorage.setItem(SUPER_ADMIN_OVERRIDE_STORAGE_KEY, String(value))
  })

  watch(selectedPlanViewUserId, value => {
    if (value) {
      localStorage.setItem(PLAN_VIEW_USER_STORAGE_KEY, value)
      return
    }
    localStorage.removeItem(PLAN_VIEW_USER_STORAGE_KEY)
  })

  watch(permissionDebugEnabled, value => {
    localStorage.setItem(PERMISSION_DEBUG_STORAGE_KEY, String(value))
  })

  return {
    isDevMode,
    superAdminOverrideEnabled,
    selectedPlanViewUserId,
    permissionDebugEnabled,
    toggleDevMode,
    toggleSuperAdminOverride,
    togglePermissionDebug,
    setSuperAdminOverrideEnabled,
    setPermissionDebugEnabled,
    setSelectedPlanViewUserId,
    clearSelectedPlanViewUserId,
  }
})

function enableDevMode() {
  const devModeStore = useDevModeStore()
  devModeStore.toggleDevMode()
}

window.enableDevMode = enableDevMode
window.enabledDevMode = enableDevMode
window.toggleSuperAdminOverride = function toggleSuperAdminOverrideWindow() {
  const devModeStore = useDevModeStore()
  devModeStore.toggleSuperAdminOverride()
}
